var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"select-none"},[_c('div',{staticClass:"leadfox-outline d-none d-md-block"},[_c('div',{staticClass:"leadfox-outline__logo"})]),_c('FreeTrial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }